import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetOnboardingContextRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetOnboardingContextResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setOnboardingContext = (request: SetOnboardingContextRequest, options?: CashRequestOptions) =>
  post<SetOnboardingContextRequest, SetOnboardingContextResponse>('/2.0/cash/set-onboarding-context', request, {
    ...options,
    rejectOnError: true,
  })
